import { Type } from 'class-transformer';

export default class EvoTalksConversaResumoModel {
  chatId!: string;

  protocolo!: string;

  numeroTelefone!: string;

  nomeContato!: string;

  @Type(() => Date) dataInicio!: Date;

  @Type(() => Date) dataFechamento!: Date;

  ultimaMensagem!: string;

  @Type(() => Date) ultimaMensagemData!: Date;

  status!: string;

  atendente!: string;

  fila!: string;

  totalMensagens!: number;

  origem!: string;

  evoChatId!: string;

  nomeEmpresa?: string;

  cnpj?: string;

  tipoContato?: string;

  endReason?: string;

  endReasonObs?: string;

  tipoConversa?: string;
}
